export const getMidiDealCategoriesPresence = (cartItems) => {
    const midiDealItems = cartItems?.midiDeal?.items || [];
    return {
        hasMain: midiDealItems.some(item => item.category?.toLowerCase() === 'main'),
        hasSnack: midiDealItems.some(item => item.category?.toLowerCase() === 'snack'),
        hasDrink: midiDealItems.some(item => item.category?.toLowerCase() === 'drink'),
    };
};

export const shouldShowMidiDealOverlay = (eligibility, cartItems, product) => {
    if (!product || !eligibility?.eligible || !eligibility?.dealActive) return false;

    if (cartItems?.midiDeal?.isActive) {
        const eligibleBarcodes = (cartItems?.midiDeal?.eligibleItems || []).map(i => i.barcode);
        const productBarcode = product?.barcode || product?.ean;
        return eligibleBarcodes.includes(productBarcode);
    }

    const category = eligibility.category?.toLowerCase();

    const { hasMain, hasSnack, hasDrink } = getMidiDealCategoriesPresence(cartItems);

    const distinctCategoriesCount = [hasMain, hasDrink, hasSnack].filter(Boolean).length;
    if (distinctCategoriesCount >= 2) {
        return false;
    }

    if (category === 'main') {
        return !hasMain;
    }

    if (category === 'drink') {
        return hasSnack;
    }

    if (category === 'snack') {
        return hasDrink;
    }

    return false;
};

export const shouldShowMidiDealProgress = (eligibility, cartItems, product) => {
    const { hasMain, hasSnack, hasDrink } = getMidiDealCategoriesPresence(cartItems);

    if (hasMain) return true;
    if (hasDrink && hasSnack) return true;

    if (!eligibility?.dealActive) return false;

    if (product && eligibility?.eligible) {
        const category = eligibility.category?.toLowerCase();

        if (category === 'main') return true;
        if (category === 'drink' && hasSnack) return true;
        if (category === 'snack' && hasDrink) return true;
    }

    return false;
};


